import { z } from "zod/v4"

export const ItemKindLook = z.literal("look").describe("ルック。")
export const ItemKindSpaceBackground = z.literal("space-background").describe("スペースの背景。")
export const ItemKindSpaceBGM = z.literal("space-bgm").describe("スペースのBGM。")

export const ItemKind = z.union([
  ItemKindLook,
  ItemKindSpaceBackground,
  ItemKindSpaceBGM,
]);

export const ItemKindEnum = z.enum([
  ItemKindLook.value,
  ItemKindSpaceBackground.value,
  ItemKindSpaceBGM.value,
]);

export type ItemKind = z.infer<typeof ItemKind>
